import { LetterIcon, PhoneIcon, SmsIcon } from '@instabox/consumer-web-ui'
import { FC, SVGProps } from 'react'

import { ContactUsType } from './types'

const ContactUsLinkIcon: FC<ContactUsType & SVGProps<SVGSVGElement>> = ({ type, ...props }) => {
  switch (type) {
    case 'email':
      return <LetterIcon {...props} color="var(--color-grey-gray)" />
    case 'phone':
      return <PhoneIcon {...props} color="var(--color-grey-gray)" />
    case 'sms':
      return <SmsIcon {...props} color="var(--color-grey-gray)" />
    default:
      return null
  }
}

export default ContactUsLinkIcon
